var Config = {
    // // development
    // urlCartilhas: "http://localhost:8080",
    // production
    appKey: "".concat(process.env.APP_KEY),
    urlCartilhas: "".concat(process.env.BASE_URL_SERVICE),
    urlAvaliacao: "".concat(process.env.MIDDLEWARE_URL, "/avaliacao"),
};
export default Config;
